import api from "!../../ClientApp/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../ClientApp/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./GWTMDark.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};